import React, { useState, Component } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { Link, Redirect} from "react-router-dom";
import './Profile.css';
import Error from "../Error/Error";
import Updated from "../Messages/Updated";
import SignupDataService from "../../services/signup.service";
var bcrypt = require('bcryptjs');


class UpdatePassword extends React.Component{


  buildOptions() {
    var arr = [];
    for (let i = 18; i <= 99; i++) {
        arr.push(<option key={i} value={i}>{i}</option>)
    }

    return arr; 
}


  constructor(props) {
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }

    super(props);
    this.state = {
      password: '',
      confirmpassword: '',
      userid: userid,
      redirect: null
    };
  }

 
 

  onPasswordChange = (event) => {
    this.setState({password: event.target.value})
  }


  onConfirmPasswordChange = (event) => {
  
    this.setState({confirmpassword: event.target.value})
  }
  

  validateForm = () => {
    return this.state.password.length >= 8 && this.state.confirmpassword.length >= 8 && this.state.password == this.state.confirmpassword;
  }

   handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({stage: 0});

    if(this.state.password != this.state.confirmpassword)
    {
        this.setState({stage: 4});
    }
    if(this.state.userid == 0)
    return;

    var salt = bcrypt.genSaltSync(10);
    var hash = bcrypt.hashSync(this.state.password, salt);


    var data = {
      password: hash,
   
    };

    await SignupDataService.update(this.state.userid, data)
    .then(response => {
      if(response.data.message == 1)
      {
        //display updated component
        this.setState({stage: 1});
        this.setState({redirect: "/updatethankyou"});
      }
      else
      {
        //display unable to updated component
        this.setState({stage: 2});
      }
    
    })
    .catch(e => {
      console.log(e);
      this.setState({stage: 3});
    });


  }

 
  render(){

    if (this.state.redirect) {
        return <Redirect to={this.state.redirect} />
      }

  return (
      
    <div  className="container col-md-6">
       <div className="col-md-12 front-text">
      {this.state.stage == 1 ? <Updated Color={'accept-color'} Message={'Password Updated.'}/> : ''}
      {this.state.stage == 2 ? <Error Message={'Unable to update your Password.'}/> : ''}
      {this.state.stage == 3 ? <Error Message={'System error. Please contact help desk.'}/> : ''}
      {this.state.stage == 4 ? <Error Message={'Passwords do not Match.'}/> : ''}
      </div>
  <span className="span"><b>Update Password</b></span>
      <Form onSubmit={this.handleSubmit}>
      <Form.Group size="lg" controlId="name">
          <Form.Label>Password</Form.Label>
          <Form.Control
            autoFocus maxLength="25" placeholder="Password"
            type="password" autoComplete="on"
            value={this.state.password}
            onChange={this.onPasswordChange.bind(this)}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="email">
          <Form.Label>Confirm</Form.Label>
          <Form.Control maxLength="25"
            placeholder="Confirm Password"
            type="password" autoComplete="on"
            value={this.state.confirmpassword}
            onChange={this.onConfirmPasswordChange.bind(this)}
          />
        </Form.Group>
    
        <Button block size="lg" type="submit" disabled={!this.validateForm()}>
          Submit 
        </Button>
        <Link  to="/home"><img width="75" src="home.png" alt="Go home" /></Link>
      </Form>
      
    </div>
  );
    

  }

}

export default UpdatePassword;